(function () {
  var bar = document.getElementById('sno-sticky');
  if (!bar || bar.dataset.snoReady) return;

  /* --- amorçage --------------------------------------------------------- */
  /* Ce snippet est rendu par 'sno-atc', plus haut dans la colonne produit que
     le formulaire d'achat : au moment où ce script s'exécute, le bouton du
     thème n'existe pas encore. On attend qu'il arrive. */
  function findForm() {
    var forms = [].slice.call(document.querySelectorAll('form[data-type="add-to-cart-form"]'));
    var f = null;
    for (var i = 0; i < forms.length; i++) {
      /* attention : form.id renvoie l'<input name="id"> du formulaire,
         pas l'attribut HTML. Il faut passer par getAttribute. */
      var fid = forms[i].getAttribute('id') || '';
      if (fid.indexOf('__main') !== -1) { f = forms[i]; break; }
    }
    if (!f) f = forms[0];
    return (f && f.querySelector('button[name="add"]')) ? f : null;
  }

  function boot() {
    var form = findForm();
    if (!form) return false;
    bar.dataset.snoReady = '1';
    start(form, form.querySelector('button[name="add"]'));
    return true;
  }

  function waitForForm() {
    if (boot()) return;
    var mo = new MutationObserver(function () { if (boot()) mo.disconnect(); });
    mo.observe(document.documentElement, { subtree: true, childList: true });
    setTimeout(function () {
      mo.disconnect();
      /* pas de formulaire d'achat sur cette page : on retire la barre */
      if (!bar.dataset.snoReady && bar.parentNode) bar.parentNode.removeChild(bar);
    }, 12000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitForForm);
  else waitForForm();

  function start(form, nativeBtn) {
    /* sortir la barre de son conteneur : un ancêtre avec transform/filter
       casserait le position:fixed */
    document.body.appendChild(bar);
    bar.hidden = false;

    var btn      = bar.querySelector('[data-sno-btn]');
    var titleEl  = bar.querySelector('[data-sno-title]');
    var metaEl   = bar.querySelector('[data-sno-meta]');
    var addTxt   = bar.dataset.add || 'Add to cart';
    var soldTxt  = bar.dataset.soldout || 'Sold out';
    var chooseTx = bar.dataset.choose || 'Choose your offer';
    var prodTitle = bar.dataset.title || '';

    /* le bouton reprend exactement la couleur du bouton du thème */
    try {
      var cs = getComputedStyle(nativeBtn);
      if (cs.backgroundColor && cs.backgroundColor !== 'rgba(0, 0, 0, 0)') {
        bar.style.setProperty('--sno-sticky-btn-bg', cs.backgroundColor);
        bar.style.setProperty('--sno-sticky-btn-fg', cs.color);
      }
    } catch (e) {}

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isWide = function () { return window.matchMedia('(min-width: 750px)').matches; };

    /* --- widget d'offres Kaching ----------------------------------------- */
    /* .kaching-bundles est dans le HTML dès le départ ; les barres n'arrivent
       qu'après l'hydratation Svelte. Tant qu'elles ne sont pas là, on considère
       qu'aucun choix n'est fait : le clic remonte au widget. */
    var kbHost = function () { return document.querySelector('.kaching-bundles'); };
    var kbBars = function () { return [].slice.call(document.querySelectorAll('.kaching-bundles__bar')); };

    function selectedBar() {
      var bars = kbBars();
      for (var i = 0; i < bars.length; i++) {
        var input = bars[i].querySelector('input[type="radio"]');
        if (bars[i].classList.contains('kaching-bundles__bar--selected') || (input && input.checked)) return bars[i];
      }
      return null;
    }

    function txt(el, sel) {
      var n = el ? el.querySelector(sel) : null;
      return n ? (n.textContent || '').trim() : '';
    }

    /* --- entête : décalage de la barre haute ------------------------------ */
    function headerHeight() {
      var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (v > 0) return v;
      var h = document.querySelector('.section-header, sticky-header, header');
      return h ? h.getBoundingClientRect().height : 0;
    }

    /* l'entête Dawn se replie quand on descend : la barre haute doit suivre son
       bas réel, sinon elle laisse une bande blanche au-dessus d'elle. */
    function headerBottom() {
      var h = document.querySelector('.section-header, sticky-header, header');
      if (!h) return 0;
      var b = h.getBoundingClientRect().bottom;
      return b > 0 ? b : 0;
    }

    function place() {
      bar.style.setProperty('--sno-sticky-top', isWide() ? Math.round(headerBottom()) + 'px' : '0px');
      var h = bar.getBoundingClientRect().height;
      if (h > 0) document.documentElement.style.setProperty('--sno-sticky-h', Math.round(h) + 'px');
    }

    /* --- contenu ---------------------------------------------------------- */
    function paint() {
      var soldOut = !!nativeBtn.disabled;
      var sel = selectedBar();

      btn.disabled = soldOut;
      btn.textContent = soldOut ? soldTxt : addTxt;

      if (sel) {
        var name = txt(sel, '.kaching-bundles__bar-title') || prodTitle;
        var now  = txt(sel, '.kaching-bundles__bar-price');
        var was  = txt(sel, '.kaching-bundles__bar-full-price');
        titleEl.textContent = name;
        metaEl.innerHTML = '';
        if (now) {
          var s = document.createElement('span');
          s.className = 'sno-sticky__price';
          s.textContent = now;
          metaEl.appendChild(s);
        }
        if (was) {
          var w = document.createElement('span');
          w.className = 'sno-sticky__was';
          w.textContent = was;
          metaEl.appendChild(w);
        }
        btn.setAttribute('aria-label', addTxt + ', ' + name);
      } else {
        titleEl.textContent = prodTitle;
        metaEl.innerHTML = '';
        var hint = document.createElement('span');
        hint.className = 'sno-sticky__hint';
        hint.textContent = (arrowUp() ? '↑ ' : '↓ ') + chooseTx;
        metaEl.appendChild(hint);
        btn.setAttribute('aria-label', chooseTx);
      }
      place();
    }

    function bundleTarget() {
      return document.querySelector('.kaching-bundles__block') || kbHost();
    }

    function arrowUp() {
      var t = bundleTarget();
      return t ? t.getBoundingClientRect().top < 0 : true;
    }

    /* --- visibilité -------------------------------------------------------- */
    var nativeVisible = true;
    /* Le bouton natif est-il sorti PAR LE HAUT ?
       Demande du fondateur (17/09/2026) : la barre ne doit jamais apparaître tant
       qu'on est AU-DESSUS du bouton d'achat. `!nativeVisible` seul ne suffit pas :
       il est vrai aussi quand le bouton est encore PLUS BAS que l'écran, donc la
       barre sortait dès le haut de page, avant même que la cliente ait vu le vrai
       bouton. On exige en plus que le bouton soit passé au-dessus du viewport. */
    function passed() {
      /* ⚠️ On RELIT le bouton dans le DOM à chaque appel. Kaching réécrit le
         formulaire d'achat à chaque sélection d'offre : la référence `nativeBtn`
         capturée au démarrage devient alors un nœud DÉTACHÉ. Un nœud détaché
         renvoie un rectangle à zéro, donc `bottom <= 0` serait toujours vrai et
         la barre resterait collée à l'écran. Deux gardes ci-dessous. */
      var b = liveBtn();
      if (!b || !document.contains(b)) return false;
      var r = b.getBoundingClientRect();
      if (r.width === 0 && r.height === 0) return false;
      return r.bottom <= 0;
    }

    function liveBtn() {
      var f = findForm();
      return (f && f.querySelector('button[name="add"]')) || nativeBtn;
    }

    function blocked() {
      /* panier ouvert, modale galerie, pop-up Klaviyo : on s'efface.
         Klaviyo pose 'klaviyo-prevent-body-scrolling' sur <body> tant que son
         formulaire est ouvert ; son voile est à z-index 90000, donc la barre
         n'est de toute façon plus cliquable, mais elle resterait visible. */
      if (document.body.classList.contains('overflow-hidden')) return true;
      if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) return true;
      if (document.querySelector('cart-drawer.active, .drawer.active, .cart-drawer.active')) return true;
      if (document.querySelector('.product-media-modal[open], product-modal[open], details-modal[open]')) return true;
      return false;
    }

    var wasShown = false;

    function update() {
      /* `nativeVisible` vient de l'IntersectionObserver, qui observe le bouton
         capturé au démarrage. Quand Kaching réécrit le formulaire, cet observateur
         ne tire plus jamais et `nativeVisible` reste figé à `true` : la barre ne
         sortait plus du tout (constaté sur la boutique US). On ne décide donc plus
         que sur `passed()`, qui est une MESURE relue à chaque appel. */
      var show = passed() && !blocked();
      if (show && !wasShown) { wasShown = true; paint(); }
      if (!show) wasShown = false;
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (!isWide()) document.body.classList.toggle('sno-sticky-pad', show);
      else document.body.classList.remove('sno-sticky-pad');
      if (show) place();
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        nativeVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(nativeBtn);
      /* `passed()` dépend de la POSITION, pas seulement du franchissement de seuil :
         l'observateur ne se redéclenche pas tant qu'on reste du même côté. On
         réévalue donc au scroll, throttlé par rAF pour ne rien coûter. */
      /* ⚠️ NE PAS nommer cette variable `tick` : un `var tick` existe déjà plus bas
         dans la même fonction (le throttle de `schedule`). `var` remonte au niveau
         de la fonction, les deux seraient la MÊME variable et se bloqueraient
         mutuellement. */
      var passTick = false;
      window.addEventListener('scroll', function () {
        if (passTick) return;
        passTick = true;
        requestAnimationFrame(function () { passTick = false; update(); });
      }, { passive: true });
    } else {
      window.addEventListener('scroll', function () {
        var r = nativeBtn.getBoundingClientRect();
        nativeVisible = r.bottom > 0 && r.top < window.innerHeight;
        update();
      }, { passive: true });
    }

    /* --- le clic ----------------------------------------------------------- */
    function pulse() {
      var t = bundleTarget();
      if (!t) return;
      var el = t.querySelector('.kaching-bundles__bars') || t;
      el.classList.remove('sno-sticky-pulse');
      void el.offsetWidth;
      el.classList.add('sno-sticky-pulse');
      setTimeout(function () { el.classList.remove('sno-sticky-pulse'); }, 1800);
    }

    function goToBundles() {
      var t = bundleTarget();
      if (!t) return;
      var offset = headerHeight() + (isWide() ? bar.getBoundingClientRect().height : 0) + 14;
      var y = t.getBoundingClientRect().top + window.pageYOffset - offset;
      try {
        window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      } catch (e) {
        window.scrollTo(0, Math.max(0, y));
      }
      setTimeout(pulse, reduce ? 0 : 420);
    }

    btn.addEventListener('click', function () {
      if (nativeBtn.disabled) return;
      if (kbHost() && !selectedBar()) { goToBundles(); return; }
      nativeBtn.click();
    });

    /* --- se tenir à jour ---------------------------------------------------- */
    var tick = null;
    function schedule() {
      if (tick) return;
      tick = setTimeout(function () { tick = null; paint(); update(); }, 90);
    }

    var mo = new MutationObserver(schedule);

    /* l'etat du panier / des modales passe par une classe sur <body> */
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

    /* le widget d'offres : on suit ses classes et ses radios, pas toute la page */
    var host = kbHost();
    if (host) {
      mo.observe(host, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
    } else {
      /* pas encore la : on attend son arrivee, puis on s'y accroche */
      var wait = new MutationObserver(function () {
        var h = kbHost();
        if (!h) return;
        wait.disconnect();
        mo.observe(h, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'checked'] });
        schedule();
      });
      wait.observe(document.body, { subtree: true, childList: true });
      setTimeout(function () { wait.disconnect(); }, 15000);
    }

    /* rupture de stock : le bouton du theme se desactive */
    mo.observe(form, { subtree: true, attributes: true, attributeFilter: ['disabled'] });

    /* suivre l'entête pendant le scroll, sans repeindre toute la barre */
    var raf = null;
    window.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        if (isWide() && bar.classList.contains('is-on')) place();
      });
    }, { passive: true });

    document.addEventListener('change', schedule, true);
    document.addEventListener('click', schedule, true);
    window.addEventListener('resize', function () { place(); update(); }, { passive: true });
    document.addEventListener('shopify:section:load', schedule);

    paint();
    update();
  }
})();